import { Component, inject, input, output } from "@angular/core";
import { NoOpLink } from "@kno2/common/directives";
import { AuthService } from "@kno2/core/auth";
import { ProfileModalComponent } from "@kno2/features/account/profile";
import { DialogService } from "@kno2/shared/dialog";

@Component({
    selector: "kno2-profile-menu",
    imports: [NoOpLink],
    templateUrl: "./profile-menu.component.html"
})
export class ProfileMenuComponent {
    private readonly authService = inject(AuthService);
    private readonly dialogService = inject(DialogService);

    protected currentUser = input.required<{ fullName: string; userId: string }>();
    protected changingPassword = input<boolean>(false);

    public onProfileUpdated = output<void>();

    public async editProfile({ changingPassword }: { changingPassword: boolean } = { changingPassword: false }): Promise<void> {
        const { result } = await this.dialogService.open(ProfileModalComponent, {
            inputValues: { changingPassword },
            headerText: "Update Profile",
            width: "800px"
        });

        if (result) {
            this.onProfileUpdated.emit();
        }
    }

    public async logout(): Promise<void> {
        await this.authService.logout();
    }
}
